import { __decorate, __param } from 'tslib';
import { Input, Directive, Inject, forwardRef, HostBinding, Component, ChangeDetectionStrategy, InjectionToken, SkipSelf, ElementRef, ContentChildren, Optional, ViewChild, EventEmitter, Output, Injectable, NgModule } from '@angular/core';
import { Subject } from 'rxjs';
import { startWith, map, distinctUntilChanged, switchMap, tap, mapTo } from 'rxjs/operators';
import { EMPTY_ARRAY, tuiDefaultProp, ALWAYS_TRUE_HANDLER, EMPTY_FUNCTION, EMPTY_QUERY, isPresent, TuiLetModule } from '@taiga-ui/cdk';
import { POLYMORPHEUS_CONTEXT, PolymorpheusComponent, PolymorpheusModule } from '@tinkoff/ng-polymorpheus';
import { CommonModule } from '@angular/common';
import { TuiExpandModule, TuiButtonModule } from '@taiga-ui/core';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';
import * as ɵngcc2 from '@taiga-ui/core';
import * as ɵngcc3 from '@tinkoff/ng-polymorpheus';
import * as ɵngcc4 from '@taiga-ui/cdk';

function TuiTreeItemContentComponent_button_0_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 2);
    ɵngcc0.ɵɵlistener("click", function TuiTreeItemContentComponent_button_0_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r2 = ɵngcc0.ɵɵnextContext(); return ctx_r2.onClick(); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("t-button_expanded", ctx_r0.isExpanded);
} }
function TuiTreeItemContentComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function TuiTreeItemComponent_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵprojection(0);
} }
function TuiTreeItemComponent_tui_expand_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "tui-expand", 4);
    ɵngcc0.ɵɵpipe(1, "async");
    ɵngcc0.ɵɵelementStart(2, "div");
    ɵngcc0.ɵɵprojection(3, 1);
    ɵngcc0.ɵɵprojection(4, 2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("expanded", ɵngcc0.ɵɵpipeBind1(1, 1, ctx_r2.expanded$));
} }
function TuiTreeItemComponent_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
const _c0 = ["*", [["tui-tree-item"]], [["tui-tree"]]];
const _c1 = function (a0, a1) { return { $implicit: a0, template: a1 }; };
const _c2 = ["*", "tui-tree-item", "tui-tree"];
const _c3 = ["value", ""];
const _c4 = function (a0, a1) { return { $implicit: a0, node: a1 }; };
function TuiTreeComponent_tui_tree_item_0_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div", 5);
} if (rf & 2) {
    ɵngcc0.ɵɵnextContext();
    const _r2 = ɵngcc0.ɵɵreference(1);
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("content", ctx_r3.content)("context", ɵngcc0.ɵɵpureFunction2(2, _c4, ctx_r3.value, _r2));
} }
function TuiTreeComponent_tui_tree_item_0_tui_tree_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "tui-tree", 6);
} if (rf & 2) {
    const child_r5 = ctx.$implicit;
    const ctx_r4 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("value", child_r5)("content", ctx_r4.content);
} }
function TuiTreeComponent_tui_tree_item_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "tui-tree-item", 1, 2);
    ɵngcc0.ɵɵtemplate(2, TuiTreeComponent_tui_tree_item_0_div_2_Template, 1, 5, "div", 3);
    ɵngcc0.ɵɵtemplate(3, TuiTreeComponent_tui_tree_item_0_tui_tree_3_Template, 1, 2, "tui-tree", 4);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const children_r1 = ctx.tuiLet;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("tuiTreeNode", ctx_r0.value);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.value !== children_r1);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", children_r1);
} }
var TuiTreeChildrenDirective_1;
let TuiTreeChildrenDirective = TuiTreeChildrenDirective_1 = class TuiTreeChildrenDirective {
    constructor() {
        this.childrenHandler = TuiTreeChildrenDirective_1.defaultHandler;
    }
    static defaultHandler(item) {
        return Array.isArray(item) ? item : EMPTY_ARRAY;
    }
};
TuiTreeChildrenDirective.ɵfac = function TuiTreeChildrenDirective_Factory(t) { return new (t || TuiTreeChildrenDirective)(); };
TuiTreeChildrenDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: TuiTreeChildrenDirective, selectors: [["tui-tree", "childrenHandler", ""]], inputs: { childrenHandler: "childrenHandler" } });
__decorate([
    Input(),
    tuiDefaultProp()
], TuiTreeChildrenDirective.prototype, "childrenHandler", void 0);

let TuiTreeItemContentComponent = class TuiTreeItemContentComponent {
    constructor(context, controller) {
        this.context = context;
        this.controller = controller;
    }
    get isExpanded() {
        return this.context.$implicit.isExpanded;
    }
    get isExpandable() {
        return (this.context.$implicit.isExpandable &&
            this.controller !== TUI_DEFAULT_TREE_CONTROLLER);
    }
    onClick() {
        this.controller.toggle(this.context.$implicit);
    }
};
TuiTreeItemContentComponent.ɵfac = function TuiTreeItemContentComponent_Factory(t) { return new (t || TuiTreeItemContentComponent)(ɵngcc0.ɵɵdirectiveInject(POLYMORPHEUS_CONTEXT), ɵngcc0.ɵɵdirectiveInject(forwardRef(() => TUI_TREE_CONTROLLER))); };
TuiTreeItemContentComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: TuiTreeItemContentComponent, selectors: [["tui-tree-item-content"]], hostVars: 2, hostBindings: function TuiTreeItemContentComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("_expandable", ctx.isExpandable);
    } }, decls: 2, vars: 2, consts: [["tuiIconButton", "", "size", "xs", "appearance", "flat", "icon", "tuiIconChevronRight", "shape", "rounded", "class", "t-button", 3, "t-button_expanded", "click", 4, "ngIf"], [4, "ngTemplateOutlet"], ["tuiIconButton", "", "size", "xs", "appearance", "flat", "icon", "tuiIconChevronRight", "shape", "rounded", 1, "t-button", 3, "click"]], template: function TuiTreeItemContentComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, TuiTreeItemContentComponent_button_0_Template, 1, 2, "button", 0);
        ɵngcc0.ɵɵtemplate(1, TuiTreeItemContentComponent_ng_container_1_Template, 1, 0, "ng-container", 1);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.isExpandable);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx.context.template);
    } }, directives: [ɵngcc1.NgIf, ɵngcc1.NgTemplateOutlet, ɵngcc2.TuiButtonComponent], styles: ["[_nghost-%COMP%]{display:flex;align-items:center}[_nghost-%COMP%]   tui-tree-item._expandable[_nghost-%COMP%]:not(._expandable), tui-tree-item._expandable   [_nghost-%COMP%]:not(._expandable){padding-left:2rem}.t-button[_ngcontent-%COMP%]{transition-property:transform;transition-duration:var(--tui-duration,300ms);transition-timing-function:ease-in-out;margin-right:.5rem}.t-button_expanded[_ngcontent-%COMP%]{transform:rotate(90deg)}"], changeDetection: 0 });
TuiTreeItemContentComponent.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [POLYMORPHEUS_CONTEXT,] }] },
    { type: undefined, decorators: [{ type: Inject, args: [forwardRef(() => TUI_TREE_CONTROLLER),] }] }
];
__decorate([
    HostBinding('class._expandable')
], TuiTreeItemContentComponent.prototype, "isExpandable", null);
TuiTreeItemContentComponent = __decorate([ __param(0, Inject(POLYMORPHEUS_CONTEXT)),
    __param(1, Inject(forwardRef(() => TUI_TREE_CONTROLLER)))
], TuiTreeItemContentComponent);

const TUI_TREE_ITEM_CONTENT = new PolymorpheusComponent(TuiTreeItemContentComponent);
const TUI_DEFAULT_TREE_CONTROLLER = {
    isExpanded: ALWAYS_TRUE_HANDLER,
    toggle: EMPTY_FUNCTION,
};

const TUI_TREE_ACCESSOR = new InjectionToken('Controller for tracking value - TuiTreeItemComponent pairs');
const TUI_TREE_CONTROLLER = new InjectionToken('Controller for expanding the tree', {
    factory: () => TUI_DEFAULT_TREE_CONTROLLER,
});
const TUI_TREE_NODE = new InjectionToken('A node of a tree view');
const TUI_TREE_LOADING = new InjectionToken('A tree node placeholder for loading', { factory: () => ({}) });
const TUI_TREE_START = new InjectionToken('A tree node starting point');
const TUI_TREE_LOADER = new InjectionToken('A service to load tree progressively');
const TUI_TREE_CONTENT = new InjectionToken('Content for a tree item', {
    factory: () => TUI_TREE_ITEM_CONTENT,
});
const TUI_TREE_LEVEL = new InjectionToken('Nesting level of current TreeView node', {
    factory: () => -1,
});

const TUI_TREE_ITEM_PROVIDERS = [
    {
        provide: TUI_TREE_LEVEL,
        deps: [[new SkipSelf(), TUI_TREE_LEVEL]],
        useFactory: treeLevelFactory,
    },
    {
        provide: TUI_TREE_NODE,
        useExisting: forwardRef(() => TuiTreeItemComponent),
    },
];
function treeLevelFactory(level) {
    return ++level;
}

let TuiTreeItemComponent = class TuiTreeItemComponent {
    constructor(elementRef, controller, level, content) {
        this.elementRef = elementRef;
        this.controller = controller;
        this.level = level;
        this.content = content;
        this.nested = EMPTY_QUERY;
        this.change$ = new Subject();
        this.expanded$ = this.change$.pipe(startWith(null), map(() => this.isExpanded), distinctUntilChanged());
        this.attached$ = this.change$.pipe(map(() => this.elementRef.nativeElement.isConnected), distinctUntilChanged());
    }
    get isExpandable() {
        return !!this.nested.length;
    }
    get isExpanded() {
        return this.controller.isExpanded(this);
    }
    ngDoCheck() {
        this.change$.next();
    }
};
TuiTreeItemComponent.ɵfac = function TuiTreeItemComponent_Factory(t) { return new (t || TuiTreeItemComponent)(ɵngcc0.ɵɵdirectiveInject(ElementRef), ɵngcc0.ɵɵdirectiveInject(forwardRef(() => TUI_TREE_CONTROLLER)), ɵngcc0.ɵɵdirectiveInject(forwardRef(() => TUI_TREE_LEVEL)), ɵngcc0.ɵɵdirectiveInject(forwardRef(() => TUI_TREE_CONTENT))); };
TuiTreeItemComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: TuiTreeItemComponent, selectors: [["tui-tree-item"]], contentQueries: function TuiTreeItemComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, TUI_TREE_NODE, false);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.nested = _t);
    } }, hostAttrs: ["role", "treeitem"], hostVars: 2, hostBindings: function TuiTreeItemComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("_expandable", ctx.isExpandable);
    } }, features: [ɵngcc0.ɵɵProvidersFeature(TUI_TREE_ITEM_PROVIDERS)], ngContentSelectors: _c2, decls: 6, vars: 9, consts: [["template", ""], ["polymorpheus-outlet", "", 3, "content", "context"], ["role", "group", "class", "t-children", 3, "expanded", 4, "ngIf"], [4, "ngIf"], ["role", "group", 1, "t-children", 3, "expanded"]], template: function TuiTreeItemComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c0);
        ɵngcc0.ɵɵtemplate(0, TuiTreeItemComponent_ng_template_0_Template, 1, 0, "ng-template", null, 0, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵelement(2, "div", 1);
        ɵngcc0.ɵɵtemplate(3, TuiTreeItemComponent_tui_expand_3_Template, 5, 3, "tui-expand", 2);
        ɵngcc0.ɵɵtemplate(4, TuiTreeItemComponent_ng_container_4_Template, 1, 0, "ng-container", 3);
        ɵngcc0.ɵɵpipe(5, "async");
    } if (rf & 2) {
        const _r0 = ɵngcc0.ɵɵreference(1);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("content", ctx.content)("context", ɵngcc0.ɵɵpureFunction2(6, _c1, ctx, _r0));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isExpandable);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ɵngcc0.ɵɵpipeBind1(5, 4, ctx.attached$));
    } }, directives: [ɵngcc3.PolymorpheusOutletComponent, ɵngcc1.NgIf, ɵngcc2.TuiExpandComponent], pipes: [ɵngcc1.AsyncPipe], styles: ["[_nghost-%COMP%]{display:block}.t-children[_ngcontent-%COMP%]{position:relative;margin-left:var(--tui-tree-item-indent,1.5rem)}"], changeDetection: 0 });
TuiTreeItemComponent.ctorParameters = () => [
    { type: ElementRef, decorators: [{ type: Inject, args: [ElementRef,] }] },
    { type: undefined, decorators: [{ type: Inject, args: [forwardRef(() => TUI_TREE_CONTROLLER),] }] },
    { type: Number, decorators: [{ type: Inject, args: [forwardRef(() => TUI_TREE_LEVEL),] }] },
    { type: undefined, decorators: [{ type: Inject, args: [forwardRef(() => TUI_TREE_CONTENT),] }] }
];
__decorate([
    ContentChildren(TUI_TREE_NODE)
], TuiTreeItemComponent.prototype, "nested", void 0);
__decorate([
    HostBinding('class._expandable')
], TuiTreeItemComponent.prototype, "isExpandable", null);
TuiTreeItemComponent = __decorate([ __param(0, Inject(ElementRef)),
    __param(1, Inject(forwardRef(() => TUI_TREE_CONTROLLER))),
    __param(2, Inject(forwardRef(() => TUI_TREE_LEVEL))),
    __param(3, Inject(forwardRef(() => TUI_TREE_CONTENT)))
], TuiTreeItemComponent);

var TuiTreeComponent_1;
let TuiTreeComponent = TuiTreeComponent_1 = class TuiTreeComponent {
    constructor(directive) {
        this.directive = directive;
        this.check$ = new Subject();
        this.children$ = this.check$.pipe(startWith(null), map(() => this.handler(this.value)), distinctUntilChanged());
        this.content = ({ $implicit }) => String($implicit);
    }
    ngDoCheck() {
        var _a, _b;
        this.check$.next();
        (_a = this.item) === null || _a === void 0 ? void 0 : _a.ngDoCheck();
        (_b = this.child) === null || _b === void 0 ? void 0 : _b.ngDoCheck();
    }
    get handler() {
        var _a, _b;
        return (_b = (_a = this.directive) === null || _a === void 0 ? void 0 : _a.childrenHandler) !== null && _b !== void 0 ? _b : TuiTreeChildrenDirective.defaultHandler;
    }
};
TuiTreeComponent.ɵfac = function TuiTreeComponent_Factory(t) { return new (t || TuiTreeComponent)(ɵngcc0.ɵɵdirectiveInject(TuiTreeChildrenDirective, 8)); };
TuiTreeComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: TuiTreeComponent, selectors: [["tui-tree", "value", ""]], viewQuery: function TuiTreeComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(TuiTreeItemComponent, true);
        ɵngcc0.ɵɵviewQuery(TuiTreeComponent_1, true);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.item = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.child = _t.first);
    } }, hostAttrs: ["role", "tree"], inputs: { content: "content", value: "value" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: TUI_TREE_NODE,
                useExisting: TuiTreeComponent_1
            },
        ])], attrs: _c3, decls: 2, vars: 3, consts: [[3, "tuiTreeNode", 4, "tuiLet"], [3, "tuiTreeNode"], ["view", ""], ["polymorpheus-outlet", "", 3, "content", "context", 4, "ngIf"], [3, "value", "content", 4, "ngFor", "ngForOf"], ["polymorpheus-outlet", "", 3, "content", "context"], [3, "value", "content"]], template: function TuiTreeComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, TuiTreeComponent_tui_tree_item_0_Template, 4, 3, "tui-tree-item", 0);
        ɵngcc0.ɵɵpipe(1, "async");
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("tuiLet", ɵngcc0.ɵɵpipeBind1(1, 1, ctx.children$));
    } }, directives: function () { return [ɵngcc4.TuiLetDirective, TuiTreeItemComponent, TuiTreeNodeDirective, ɵngcc1.NgIf, ɵngcc1.NgForOf, ɵngcc3.PolymorpheusOutletComponent, TuiTreeComponent]; }, pipes: function () { return [ɵngcc1.AsyncPipe]; }, styles: ["[_nghost-%COMP%]{position:relative;display:block}"], changeDetection: 0 });
TuiTreeComponent.ctorParameters = () => [
    { type: TuiTreeChildrenDirective, decorators: [{ type: Optional }, { type: Inject, args: [TuiTreeChildrenDirective,] }] }
];
__decorate([
    Input()
], TuiTreeComponent.prototype, "value", void 0);
__decorate([
    ViewChild(TuiTreeItemComponent)
], TuiTreeComponent.prototype, "item", void 0);
__decorate([
    ViewChild(TuiTreeComponent_1)
], TuiTreeComponent.prototype, "child", void 0);
__decorate([
    Input()
], TuiTreeComponent.prototype, "content", void 0);
TuiTreeComponent = TuiTreeComponent_1 = __decorate([ __param(0, Optional()),
    __param(0, Inject(TuiTreeChildrenDirective))
], TuiTreeComponent);

var TuiTreeControllerDirective_1;
let TuiTreeControllerDirective = TuiTreeControllerDirective_1 = class TuiTreeControllerDirective {
    constructor() {
        this.fallback = true;
        this.map = new Map();
        this.toggled = new EventEmitter();
        this.items = new Map();
    }
    register(item, value) {
        this.items.set(item, value);
    }
    unregister(item) {
        this.items.delete(item);
    }
    isExpanded(item) {
        var _a;
        const value = this.items.get(item);
        return (_a = (value && this.map.get(value))) !== null && _a !== void 0 ? _a : this.fallback;
    }
    toggle(item) {
        const value = this.items.get(item);
        const expanded = this.isExpanded(item);
        if (!isPresent(value)) {
            return;
        }
        this.toggled.emit(value);
        this.map.set(value, !expanded);
    }
};
TuiTreeControllerDirective.ɵfac = function TuiTreeControllerDirective_Factory(t) { return new (t || TuiTreeControllerDirective)(); };
TuiTreeControllerDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: TuiTreeControllerDirective, selectors: [["", "tuiTreeController", "", "map", ""]], inputs: { fallback: ["tuiTreeController", "fallback"], map: "map" }, outputs: { toggled: "toggled" }, exportAs: ["tuiTreeController"], features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: TUI_TREE_ACCESSOR,
                useExisting: TuiTreeControllerDirective_1
            },
            {
                provide: TUI_TREE_CONTROLLER,
                useExisting: TuiTreeControllerDirective_1
            },
        ])] });
__decorate([
    Input('tuiTreeController'),
    tuiDefaultProp()
], TuiTreeControllerDirective.prototype, "fallback", void 0);
__decorate([
    Input(),
    tuiDefaultProp()
], TuiTreeControllerDirective.prototype, "map", void 0);
__decorate([
    Output()
], TuiTreeControllerDirective.prototype, "toggled", void 0);

var TuiTreeItemControllerDirective_1;
let TuiTreeItemControllerDirective = TuiTreeItemControllerDirective_1 = class TuiTreeItemControllerDirective {
    constructor() {
        this.map = new WeakMap();
        this.fallback = true;
    }
    isExpanded(item) {
        var _a;
        return (_a = this.map.get(item)) !== null && _a !== void 0 ? _a : this.fallback;
    }
    toggle(item) {
        this.map.set(item, !this.isExpanded(item));
    }
};
TuiTreeItemControllerDirective.ɵfac = function TuiTreeItemControllerDirective_Factory(t) { return new (t || TuiTreeItemControllerDirective)(); };
TuiTreeItemControllerDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: TuiTreeItemControllerDirective, selectors: [["", "tuiTreeController", "", 3, "map", ""]], inputs: { fallback: ["tuiTreeController", "fallback"] }, exportAs: ["tuiTreeController"], features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: TUI_TREE_CONTROLLER,
                useExisting: TuiTreeItemControllerDirective_1
            },
        ])] });
__decorate([
    Input('tuiTreeController'),
    tuiDefaultProp()
], TuiTreeItemControllerDirective.prototype, "fallback", void 0);

let TuiTreeNodeDirective = class TuiTreeNodeDirective {
    constructor(directive, component) {
        this.directive = directive;
        this.component = component;
    }
    set value(value) {
        var _a;
        (_a = this.directive) === null || _a === void 0 ? void 0 : _a.register(this.component, value);
    }
    ngOnDestroy() {
        var _a;
        (_a = this.directive) === null || _a === void 0 ? void 0 : _a.unregister(this.component);
    }
};
TuiTreeNodeDirective.ɵfac = function TuiTreeNodeDirective_Factory(t) { return new (t || TuiTreeNodeDirective)(ɵngcc0.ɵɵdirectiveInject(TUI_TREE_ACCESSOR, 8), ɵngcc0.ɵɵdirectiveInject(TuiTreeItemComponent)); };
TuiTreeNodeDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: TuiTreeNodeDirective, selectors: [["tui-tree-item", "tuiTreeNode", ""]], inputs: { value: ["tuiTreeNode", "value"] } });
TuiTreeNodeDirective.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Optional }, { type: Inject, args: [TUI_TREE_ACCESSOR,] }] },
    { type: TuiTreeItemComponent, decorators: [{ type: Inject, args: [TuiTreeItemComponent,] }] }
];
__decorate([
    Input('tuiTreeNode')
], TuiTreeNodeDirective.prototype, "value", null);
TuiTreeNodeDirective = __decorate([ __param(0, Optional()),
    __param(0, Inject(TUI_TREE_ACCESSOR)),
    __param(1, Inject(TuiTreeItemComponent))
], TuiTreeNodeDirective);

// @dynamic
let TuiTreeService = class TuiTreeService {
    constructor(loading, start, loader) {
        this.loading = loading;
        this.start = start;
        this.loader = loader;
        this.map = new Map([[this.loading, []]]);
        this.load$ = new Subject();
        this.data$ = this.load$.pipe(switchMap(item => this.loader.loadChildren(item).pipe(tap(children => this.map.set(item, children)), map(children => children.filter(item => !this.loader.hasChildren(item))), tap(children => children.forEach(child => this.map.set(child, []))))), startWith(null), mapTo(this.start));
    }
    getChildren(item) {
        var _a;
        return (_a = this.map.get(item)) !== null && _a !== void 0 ? _a : [this.loading];
    }
    loadChildren(item) {
        if (this.map.get(item)) {
            return;
        }
        this.map.set(item, [this.loading]);
        this.load$.next(item);
    }
};
TuiTreeService.ɵfac = function TuiTreeService_Factory(t) { return new (t || TuiTreeService)(ɵngcc0.ɵɵinject(TUI_TREE_LOADING), ɵngcc0.ɵɵinject(TUI_TREE_START), ɵngcc0.ɵɵinject(TUI_TREE_LOADER)); };
TuiTreeService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: TuiTreeService, factory: function (t) { return TuiTreeService.ɵfac(t); } });
TuiTreeService.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [TUI_TREE_LOADING,] }] },
    { type: undefined, decorators: [{ type: Inject, args: [TUI_TREE_START,] }] },
    { type: undefined, decorators: [{ type: Inject, args: [TUI_TREE_LOADER,] }] }
];
TuiTreeService = __decorate([ __param(0, Inject(TUI_TREE_LOADING)),
    __param(1, Inject(TUI_TREE_START)),
    __param(2, Inject(TUI_TREE_LOADER))
], TuiTreeService);

let TuiTreeModule = class TuiTreeModule {
};
TuiTreeModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: TuiTreeModule });
TuiTreeModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function TuiTreeModule_Factory(t) { return new (t || TuiTreeModule)(); }, imports: [[
            CommonModule,
            PolymorpheusModule,
            TuiExpandModule,
            TuiLetModule,
            TuiButtonModule,
        ]] });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TuiTreeChildrenDirective, [{
        type: Directive,
        args: [{
                selector: 'tui-tree[childrenHandler]'
            }]
    }], function () { return []; }, { childrenHandler: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TuiTreeItemContentComponent, [{
        type: Component,
        args: [{
                selector: 'tui-tree-item-content',
                template: "<button\n    *ngIf=\"isExpandable\"\n    tuiIconButton\n    size=\"xs\"\n    appearance=\"flat\"\n    icon=\"tuiIconChevronRight\"\n    shape=\"rounded\"\n    class=\"t-button\"\n    [class.t-button_expanded]=\"isExpanded\"\n    (click)=\"onClick()\"\n></button>\n<ng-container *ngTemplateOutlet=\"context.template\"></ng-container>\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                styles: [":host{display:flex;align-items:center}:host :host-context(tui-tree-item._expandable):not(._expandable){padding-left:2rem}.t-button{transition-property:transform;transition-duration:var(--tui-duration,300ms);transition-timing-function:ease-in-out;margin-right:.5rem}.t-button_expanded{transform:rotate(90deg)}"]
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [POLYMORPHEUS_CONTEXT]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [forwardRef(() => TUI_TREE_CONTROLLER)]
            }] }]; }, { isExpandable: [{
            type: HostBinding,
            args: ['class._expandable']
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TuiTreeItemComponent, [{
        type: Component,
        args: [{
                selector: 'tui-tree-item',
                template: "<ng-template #template><ng-content></ng-content></ng-template>\n<div\n    polymorpheus-outlet\n    [content]=\"content\"\n    [context]=\"{$implicit: this, template: template}\"\n></div>\n<tui-expand\n    *ngIf=\"isExpandable\"\n    role=\"group\"\n    class=\"t-children\"\n    [expanded]=\"expanded$ | async\"\n>\n    <div>\n        <ng-content select=\"tui-tree-item\"></ng-content>\n        <ng-content select=\"tui-tree\"></ng-content>\n    </div>\n</tui-expand>\n<ng-container *ngIf=\"attached$ | async\"></ng-container>\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                providers: TUI_TREE_ITEM_PROVIDERS,
                host: {
                    role: 'treeitem'
                },
                styles: [":host{display:block}.t-children{position:relative;margin-left:var(--tui-tree-item-indent,1.5rem)}"]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef, decorators: [{
                type: Inject,
                args: [ElementRef]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [forwardRef(() => TUI_TREE_CONTROLLER)]
            }] }, { type: Number, decorators: [{
                type: Inject,
                args: [forwardRef(() => TUI_TREE_LEVEL)]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [forwardRef(() => TUI_TREE_CONTENT)]
            }] }]; }, { nested: [{
            type: ContentChildren,
            args: [TUI_TREE_NODE]
        }], isExpandable: [{
            type: HostBinding,
            args: ['class._expandable']
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TuiTreeComponent, [{
        type: Component,
        args: [{
                selector: 'tui-tree[value]',
                template: "<tui-tree-item\n    *tuiLet=\"children$ | async as children\"\n    #view\n    [tuiTreeNode]=\"value\"\n>\n    <div\n        *ngIf=\"value !== children\"\n        polymorpheus-outlet\n        [content]=\"content\"\n        [context]=\"{$implicit: value, node: view}\"\n    ></div>\n    <tui-tree\n        *ngFor=\"let child of children\"\n        [value]=\"child\"\n        [content]=\"content\"\n    ></tui-tree>\n</tui-tree-item>\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                providers: [
                    {
                        provide: TUI_TREE_NODE,
                        useExisting: TuiTreeComponent_1
                    },
                ],
                host: {
                    role: 'tree'
                },
                styles: [":host{position:relative;display:block}"]
            }]
    }], function () { return [{ type: TuiTreeChildrenDirective, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [TuiTreeChildrenDirective]
            }] }]; }, { content: [{
            type: Input
        }], value: [{
            type: Input
        }], item: [{
            type: ViewChild,
            args: [TuiTreeItemComponent]
        }], child: [{
            type: ViewChild,
            args: [TuiTreeComponent_1]
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TuiTreeControllerDirective, [{
        type: Directive,
        args: [{
                selector: '[tuiTreeController][map]',
                exportAs: 'tuiTreeController',
                providers: [
                    {
                        provide: TUI_TREE_ACCESSOR,
                        useExisting: TuiTreeControllerDirective_1
                    },
                    {
                        provide: TUI_TREE_CONTROLLER,
                        useExisting: TuiTreeControllerDirective_1
                    },
                ]
            }]
    }], function () { return []; }, { fallback: [{
            type: Input,
            args: ['tuiTreeController']
        }], map: [{
            type: Input
        }], toggled: [{
            type: Output
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TuiTreeItemControllerDirective, [{
        type: Directive,
        args: [{
                selector: '[tuiTreeController]:not([map])',
                exportAs: 'tuiTreeController',
                providers: [
                    {
                        provide: TUI_TREE_CONTROLLER,
                        useExisting: TuiTreeItemControllerDirective_1
                    },
                ]
            }]
    }], function () { return []; }, { fallback: [{
            type: Input,
            args: ['tuiTreeController']
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TuiTreeNodeDirective, [{
        type: Directive,
        args: [{
                selector: 'tui-tree-item[tuiTreeNode]'
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [TUI_TREE_ACCESSOR]
            }] }, { type: TuiTreeItemComponent, decorators: [{
                type: Inject,
                args: [TuiTreeItemComponent]
            }] }]; }, { value: [{
            type: Input,
            args: ['tuiTreeNode']
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TuiTreeService, [{
        type: Injectable
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [TUI_TREE_LOADING]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [TUI_TREE_START]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [TUI_TREE_LOADER]
            }] }]; }, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(TuiTreeModule, { declarations: function () { return [TuiTreeComponent, TuiTreeItemComponent, TuiTreeItemContentComponent, TuiTreeChildrenDirective, TuiTreeItemControllerDirective, TuiTreeControllerDirective, TuiTreeNodeDirective]; }, imports: function () { return [CommonModule,
        PolymorpheusModule,
        TuiExpandModule,
        TuiLetModule,
        TuiButtonModule]; }, exports: function () { return [TuiTreeComponent, TuiTreeItemComponent, TuiTreeChildrenDirective, TuiTreeItemControllerDirective, TuiTreeControllerDirective]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TuiTreeModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    PolymorpheusModule,
                    TuiExpandModule,
                    TuiLetModule,
                    TuiButtonModule,
                ],
                entryComponents: [TuiTreeItemContentComponent],
                declarations: [
                    TuiTreeComponent,
                    TuiTreeItemComponent,
                    TuiTreeItemContentComponent,
                    TuiTreeChildrenDirective,
                    TuiTreeItemControllerDirective,
                    TuiTreeControllerDirective,
                    TuiTreeNodeDirective,
                ],
                exports: [
                    TuiTreeComponent,
                    TuiTreeItemComponent,
                    TuiTreeChildrenDirective,
                    TuiTreeItemControllerDirective,
                    TuiTreeControllerDirective,
                ]
            }]
    }], null, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { TUI_DEFAULT_TREE_CONTROLLER, TUI_TREE_ACCESSOR, TUI_TREE_CONTENT, TUI_TREE_CONTROLLER, TUI_TREE_ITEM_CONTENT, TUI_TREE_ITEM_PROVIDERS, TUI_TREE_LEVEL, TUI_TREE_LOADER, TUI_TREE_LOADING, TUI_TREE_NODE, TUI_TREE_START, TuiTreeChildrenDirective, TuiTreeComponent, TuiTreeControllerDirective, TuiTreeItemComponent, TuiTreeItemContentComponent, TuiTreeItemControllerDirective, TuiTreeModule, TuiTreeNodeDirective, TuiTreeService, treeLevelFactory };

//# sourceMappingURL=taiga-ui-kit-components-tree.js.map